import {
  FETCH_LAST_TERMS_AND_CONDITIONS_SUCCESS,
  SIGN_TERMS_AND_CONDITIONS_FAILURE,
  SIGN_TERMS_AND_CONDITIONS_SUCCESS,
  SIGN_TERMS_AND_CONDITIONS_LOADING,
} from './actionTypes';
import { type ControllerHomepageAction } from './actions';
import { type TermsAndConditions } from './types';

type TipsStatusStatus = 'success' | 'failure';

type State = {
  lastTermsAndConditions: TermsAndConditions | null;
  tips: {
    status: {
      loading: boolean;
      status?: TipsStatusStatus;
    };
  };
  signTaC: { loading: boolean };
};

const initialState: State = {
  lastTermsAndConditions: null,
  tips: {
    status: {
      loading: true,
      status: undefined,
    },
  },
  signTaC: { loading: false },
};

export const reducer = (
  state: State = initialState,
  action: ControllerHomepageAction,
): State => {
  switch (action.type) {
    case FETCH_LAST_TERMS_AND_CONDITIONS_SUCCESS:
      return { ...state, lastTermsAndConditions: action.payload };
    case SIGN_TERMS_AND_CONDITIONS_FAILURE:
      return {
        ...state,
        signTaC: { loading: false },
      };
    case SIGN_TERMS_AND_CONDITIONS_LOADING:
      return {
        ...state,
        signTaC: { loading: true },
      };
    case SIGN_TERMS_AND_CONDITIONS_SUCCESS:
      return {
        ...state,
        signTaC: { loading: false },
      };
    default:
      return state;
  }
};
